export const en = {
  activityPage: {
    spotlight: "'s Volunteer Spotlight",
    view_all_events: 'View All Events',
    empty_events_title: 'No Events Yet',
    empty_events_desc:
      'Looks like there are no upcoming volunteer events at your company. Request an event or create your own to go on one with your team!',
    request_button: 'Request Event',
    morning: 'Good Morning',
    afternoon: 'Good Afternoon',
    evening: 'Good Evening',
    hi: 'Hi',
    greeting_desc: "Let's get volunteering with ",
    greeting_desc_greenshield:
      'Driven by our mission of Better Health for All, we’re committed to making a meaningful impact',
    quickLinks: {
      title: 'Quick Links',
    },
    gallery: {
      title: 'Gallery',
      description: 'View All',
    },
  },
}
